import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { BANNER_HEIGHT } from 'components/Banner';
import Theme from 'styles/theme';

const HEADER_HEIGHT = 60;
const FOOTER_HEIGHT = 42;

const TopNavigationDrawerDesktop = ({ l1ActiveNode, children }) => (
  <div id="top-navigation-drawer-desktop" className="TopNavigationDrawerDesktop">
    <div
      className={classnames('TopNavigationDrawerDesktop__content', {
        'TopNavigationDrawerDesktop__content--open': !!l1ActiveNode,
      })}
    >
      {/* key prop retriggers attached CSS animation when switching l0 nodes */}
      {!!l1ActiveNode && (
        <div
          key={l1ActiveNode && l1ActiveNode.id}
          className="TopNavigationDrawerDesktop__content-inner"
        >
          {children}
        </div>
      )}
    </div>

    <style jsx>
      {`
        .TopNavigationDrawerDesktop {
          position: relative;
          width: 100%;
          background-color: ${Theme.get('colors-white')};
        }

        .TopNavigationDrawerDesktop__content {
          background-color: ${Theme.get('colors-white')};
          overflow-x: hidden;
          overflow-y: scroll;
        }

        .TopNavigationDrawerDesktop__content-inner {
          animation: ${Theme.get('transition-duration-ms')} fadeIn;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .TopNavigationDrawerDesktop__content {
          max-height: 0;
          transition: max-height ${Theme.get('transition-duration-ms')} ease-out;
        }

        .TopNavigationDrawerDesktop__content--open {
          max-height: calc(100vh - ${HEADER_HEIGHT + FOOTER_HEIGHT}px);
        }
      `}
    </style>
    <style jsx global>
      {`
        .TopNavigationDrawerDesktop__footer {
          width: 100%;
          animation: ${Theme.get('transition-duration-fast-ms')} ease-out
            ${Theme.get('transition-duration-ms')} fadeIn;
        }

        .TopNavigationDrawerDesktop__footer-chevron {
          transform: translateY(0);
          transition: transform ${Theme.get('transition-duration-ms')} ease-in-out;
        }

        .TopNavigationDrawerDesktop__footer:hover .TopNavigationDrawerDesktop__footer-chevron {
          transform: translateY(-2px);
        }

        .Banner--visible .TopNavigationDrawerDesktop__content--open {
          max-height: calc(100vh - ${HEADER_HEIGHT + BANNER_HEIGHT + FOOTER_HEIGHT}px);
        }
      `}
    </style>
  </div>
);

TopNavigationDrawerDesktop.propTypes = {
  l1ActiveNode: PropTypes.shape({ id: PropTypes.string.isRequired }),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

TopNavigationDrawerDesktop.defaultProps = {
  l1ActiveNode: null,
  children: null,
};

export default TopNavigationDrawerDesktop;
